exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "region-filter .region-filter-button {\n  margin-right: 5px;\n}\n", ""]);

